"use client";

import { c as _c } from "react/compiler-runtime";
import React from "react";
import { Label } from "@/components/ui/label";
import type { Table, TableAnswer } from "@/types/forms/question";
import type { NoteAnswerDetail, NoteQuestionDetail } from "@/types/notes";
import { TableGrid } from "./table-grid";
interface TableAnswerEditorProps {
  answer: NoteAnswerDetail;
  question: NoteQuestionDetail;
  onChange: (answerId: string, data: Record<string, unknown>) => void;
  disabled?: boolean;
  title?: string;
}
function readAnswer(data: NoteAnswerDetail["data"]): TableAnswer | undefined {
  const value = (data as {
    value?: unknown;
  })?.value;
  if (!value || typeof value !== "object") return undefined;
  return value as TableAnswer;
}
export const TableAnswerEditor: React.FC<TableAnswerEditorProps> = t0 => {
  const $ = _c(30);
  const {
    answer,
    question,
    onChange,
    disabled: t1,
    title
  } = t0;
  const disabled = t1 === undefined ? false : t1;
  const config = question.data as Table;
  let t2;
  if ($[0] !== answer.data) {
    t2 = readAnswer(answer.data);
    $[0] = answer.data;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const saved = t2;
  const hasSnapshot = !!saved?.rows?.length && !!saved?.columns?.length;
  let t3;
  if ($[2] !== config.rows || $[3] !== hasSnapshot || $[4] !== saved) {
    t3 = hasSnapshot ? saved.rows : config.rows ?? [];
    $[2] = config.rows;
    $[3] = hasSnapshot;
    $[4] = saved;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const rows = t3;
  let t4;
  if ($[6] !== config.columns || $[7] !== hasSnapshot || $[8] !== saved) {
    t4 = hasSnapshot ? saved.columns : config.columns ?? [];
    $[6] = config.columns;
    $[7] = hasSnapshot;
    $[8] = saved;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  const columns = t4;
  const lockedRows = config.rows?.length ?? 0;
  const lockedCols = config.columns?.length ?? 0;
  if (rows.length === 0 || columns.length === 0) {
    let t5;
    if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
      t5 = <p className="text-body text-foreground-muted">This table has no rows or columns configured.</p>;
      $[10] = t5;
    } else {
      t5 = $[10];
    }
    return t5;
  }
  let t5;
  if ($[11] !== title) {
    t5 = title && <Label className="text-body-strong">{title}</Label>;
    $[11] = title;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  const t6 = saved?.cells;
  const t7 = saved?.widths;
  let t8;
  if ($[13] !== answer.data || $[14] !== answer.id || $[15] !== disabled || $[16] !== onChange) {
    t8 = disabled ? undefined : next => onChange(answer.id, {
      ...answer.data,
      value: {
        rows: next.rows,
        columns: next.columns,
        cells: next.cells,
        widths: next.widths
      } satisfies TableAnswer
    });
    $[13] = answer.data;
    $[14] = answer.id;
    $[15] = disabled;
    $[16] = onChange;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  let t9;
  if ($[18] !== columns || $[19] !== disabled || $[20] !== lockedCols || $[21] !== lockedRows || $[22] !== rows || $[23] !== t6 || $[24] !== t7 || $[25] !== t8) {
    t9 = <TableGrid rows={rows} columns={columns} cells={t6} widths={t7} disabled={disabled} editableCells={true} lockedRows={lockedRows} lockedCols={lockedCols} resizable={true} onChange={t8} />;
    $[18] = columns;
    $[19] = disabled;
    $[20] = lockedCols;
    $[21] = lockedRows;
    $[22] = rows;
    $[23] = t6;
    $[24] = t7;
    $[25] = t8;
    $[26] = t9;
  } else {
    t9 = $[26];
  }
  let t10;
  if ($[27] !== t5 || $[28] !== t9) {
    t10 = <div className="space-y-3">{t5}{t9}</div>;
    $[27] = t5;
    $[28] = t9;
    $[29] = t10;
  } else {
    t10 = $[29];
  }
  return t10;
};